import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { MessageCircle, Globe } from 'lucide-react';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section id="book" className="relative py-32 overflow-hidden flex items-center justify-center" data-id="element-90">
      <div className="absolute inset-0" data-id="element-91">
        <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2000&auto=format&fit=crop" alt="Turquoise Caribbean beach in Puerto Rico" className="w-full h-full object-cover object-center" data-id="element-92" />
        <div className="absolute inset-0 bg-ocean-dark/80 mix-blend-multiply" data-id="element-93" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-94">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-6xl font-heading font-bold text-white mb-12 drop-shadow-lg" data-id="element-95">
          {t.finalCta.headline}
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-96">
          <a href="#home" className="flex items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-light text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-xl w-full sm:w-auto" data-id="element-97">
            <MessageCircle size={20} data-id="element-98" />
            {t.finalCta.btnWhatsapp}
          </a>
          <a href="https://bluoceantours.com/booking" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105 w-full sm:w-auto" data-id="element-99">
            <Globe size={20} data-id="element-100" />
            {t.finalCta.btnWebsite}
          </a>
        </motion.div>
      </div>
    </section>;
}